import { ReportGridStore } from 'domains/ReportViewer/views/grid/ReportGridStore';

export function getSelectAll(state: ReportGridStore) {
  return (
    state.rows.length > 0 &&
    (state.getReportViewerStoreState().includeAllPagesInMultiSelection
      ? state.selectedRowKeys.length === state.allRowIds.length
      : state.selectedRowKeys.length >= state.rows.length)
  );
}

export const ReportGridStoreUtils = {
  getSelectAll,
};
